let SMPNum = require("../../SMPNum");

let SequenceName = {
    "CostHero" : "CostHero",
    "DropCoins" : "DropCoins",
    "CostSupport" : "CostSupport",
    "HPGhost" : "HPGhost",
    "HPBoss" : "HPBoss",
    "HPZoneBoss": "HPZoneBoss",
    "DMGHero" : "DMGHero",
    "DMGBoss" : "DMGBoss"
}

class SMPMathCore {
    K_GAME_INTRO = 0;
    K_GAME_TUNNEL_1 = 1;
    // K_GAME_TUNNEL_2 = 2;
    // K_GAME_TUNNEL_3 = 3;

    resultSequenceDefault = [];

    isLoadedFromGamePlay = false;
    ratioSeriesCommon = [];
    ratioFirstTerm = [];

    goldDropCustomConfig = {};

    constructor(ratios, goldDropCustomConfig) {
        this.resultSequenceDefault = [];
        this.resultSequenceDefault.push(this.SequenceInterval(1, 100));
        this.resultSequenceDefault.push(this.SequenceInterval(101, 200));

        this.updateRatio(ratios);

        this.updateGoldDropCustomConfig(goldDropCustomConfig);
    }

    GetMaxIntervalIndex(){
        //=> max interval from level 500001 -> 110000000
        return 500;
    }

    GetIntervalIndex(level){
        //  1->100 => 0
        //101->200 => 1
        //201->300 => 2
        return Math.floor((level - 1) / 100);
    }

    GetSequenceInteral(index){
        if (index >= this.GetMaxIntervalIndex()){
            //=> max interval from level 500001->110000000
            let seq = this.SequenceInterval(500001, 110000000);
            seq.indexInterval = index;
            return seq;
        } else {
            //0 =>   1->100
            //1 => 101->200
            //2 => 201->300
            let start = (index * 100) + 1;
            let seq = this.SequenceInterval(start, start + 99)
            seq.indexInterval = index;
            return seq;
        }
    }

    updateRatio(ratios){
        if (ratios) {
            let keyRatio = Object.keys(ratios);
            keyRatio.forEach(key => {
                let keyValue = Object.keys(ratios[key]);
                keyValue.forEach(kv => {
                    //console.log(key+"_"+kv+"_"+ratios[key][kv]);
                    this.SetRatioConfigByKey(key + "_" + kv, ratios[key][kv]);
                });
            });
            this.isLoadedFromGamePlay = true;
        }
    }

    updateGoldDropCustomConfig(config){
        this.goldDropCustomConfig = config;
    }

    SequenceInterval(s, m) {
        return {
            "start": s,
            "max": m,
            "indexInterval": 0
        };
    }

    GetSeriesCommonRatioGamePlay(indexInterval, seriesName) {
        //console.log("getRS: "+"SeriesCommon_" + seriesName + indexInterval);
        return this.ratioSeriesCommon["SeriesCommon_" + seriesName + indexInterval];
    }

    GetFirstTermRatioGamePlay(indexInterval, seriesName) {
        return this.ratioFirstTerm["FirstTerm_" + seriesName + indexInterval];
    }

    SetRatioSeriesCommon(key, value) {
        this.ratioSeriesCommon[key] = value;
        //console.log("setRS: "+key+"="+value);
    }

    SetRatioFirstTerm(key, value) {
        this.ratioFirstTerm[key] = value;
        //console.log("setFT: "+key+"="+value);
    }

    SetRatioConfigByKey(key, ratio) {
        let pre = "";
        let isCommon = false;
        if (key.includes("Common")) {
            key = key.replace(" Common", "");
            pre = "SeriesCommon_";
            isCommon = true;
        } else {
            key = key.replace(" FirstTerm", "");
            pre = "FirstTerm_";
        }
        if (key.includes("_INTRO")) {
            key = key.replace("_INTRO", "0");
        } else if (key.includes("_TUNNEL_")) {
            key = key.replace("_TUNNEL_", "");
        } else {
            key = key.replace("_DEFAULT", "4");
        }

        let keyType = pre + key;
        if (isCommon) {
            this.SetRatioSeriesCommon(keyType, ratio);
        } else {
            this.SetRatioFirstTerm(keyType, ratio);
        }
    }

    GetSeriesFirstTermByLevel(level, seriesName) {
        if (seriesName === SequenceName.DropCoins){
            //let firstTerm = this.GetSeriesFirstTerm(this.GetIntervalIndex(level), seriesName).ToDoubleValue();//convert to float for allow it locat as negative number

            //https://www.desmos.com/calculator/madwulnvaa

            let goldDropCustomConfig = this.goldDropCustomConfig;
            let lineRef = goldDropCustomConfig.startLineRef;
            let amplitude;

            if (level <= 100)
            {
                amplitude = goldDropCustomConfig.freqFirst100Level * Math.sin((level + goldDropCustomConfig.startPoint) / goldDropCustomConfig.lengthFreq);
            }
            else
            {
                lineRef = goldDropCustomConfig.startLineRef + goldDropCustomConfig.lineRefDiff * Math.floor(level / goldDropCustomConfig.levelPerDiffFreq);
                if (level <= 1000)
                {
                    lineRef = Math.min(lineRef, goldDropCustomConfig.maxFreqLine1k);//6.9);
                }
                else
                {
                    lineRef = Math.min(lineRef, goldDropCustomConfig.maxFreqLine10k);//8.25);
                }
                let floorRange = Math.floor(level / goldDropCustomConfig.levelPerDiffFreq);
                let freq = Math.min(goldDropCustomConfig.startFreq + goldDropCustomConfig.diffFreq * floorRange, goldDropCustomConfig.maxFreq);
                amplitude = freq * Math.sin((level + goldDropCustomConfig.startPoint) / goldDropCustomConfig.lengthFreq);
            }

            let finalFirstTerm = Math.max(lineRef + amplitude, 0.01);//first term of gold drop can't be under or equal 0

            return SMPNum.fromNum(finalFirstTerm);
        } else {
            return this.GetSeriesFirstTerm(this.GetIntervalIndex(level), seriesName);
        }
    }

    GetTermValueForSeries(level, seriesName) {

        let commonRatio = this.GetSeriesCommonRatioByLevel(level, seriesName);
        if (commonRatio === -1) {
            console.log("cant generate series without ratio");
        }

        //remove some line of code reduce new object and same result
        return new SMPNum(commonRatio).PowfromInt(level - 1);
    }

    GetSeriesCommonRatioByLevel(level, seriesName) {
        return this.GetSeriesCommonRatio(this.GetIntervalIndex(level), seriesName);
    }

    GetSeriesFirstTerm(indexInterval, seriesName) {
        if (seriesName !== SequenceName.CostHero
            && seriesName !== SequenceName.CostSupport
            && seriesName !== SequenceName.DropCoins)
        {
            //indexInterval = indexInterval <= 1? indexInterval : 1;
            return SMPNum.fromNum(this.GetFirstTermRatioGamePlay(0, seriesName));
        }

        // indexInterval[0,1] => return normal
        // indexInterval[2,max] => return dynamic ratio = [0] + index * ([1]-[0])
        let ratio;
        if (indexInterval < 2)
        {
            ratio = this.GetFirstTermRatioGamePlay(indexInterval, seriesName);
        }
        else
        {
            let baseRatio = this.GetFirstTermRatioGamePlay(0, seriesName);
            let nextRatio = this.GetFirstTermRatioGamePlay(1, seriesName);
            ratio = baseRatio + this.roundBy6Dec(nextRatio - baseRatio) * indexInterval;
        }

        ratio = this.roundBy6Dec(ratio);
        // if(seriesName === SequenceName.DropCoins) console.log(`FirstTerm seriesName: ${seriesName} indexInterval: ${indexInterval} ratio: ${ratio}`);
        return SMPNum.fromNum(ratio);
    }

    GetSeriesCommonRatio(indexInterval, seriesName) {
        if (seriesName !== SequenceName.CostHero
            && seriesName !== SequenceName.CostSupport
            && seriesName !== SequenceName.DropCoins)
        {
            //indexInterval = indexInterval <= 1 ? indexInterval : 1;
            return this.roundBy6Dec(this.GetSeriesCommonRatioGamePlay(0, seriesName));
        }

        // indexInterval[0,1] => return normal
        // indexInterval[2,max] => return dynamic ratio = [0] + index * ([1]-[0])
        let ratio;
        if (indexInterval < 2)
        {
            ratio = this.GetSeriesCommonRatioGamePlay(indexInterval, seriesName);
        }
        else
        {
            let baseRatio = this.GetSeriesCommonRatioGamePlay(0, seriesName);
            let nextRatio = this.GetSeriesCommonRatioGamePlay(1, seriesName);
            ratio = baseRatio + this.roundBy6Dec(nextRatio - baseRatio) * indexInterval;
            //if(seriesName === SequenceName.DropCoins && indexInterval === 199) console.log(`SeriesCommonRatio seriesName: ${seriesName} indexInterval: ${indexInterval} ratio: ${ratio}`);
        }

        //to fix no hard level 15K or 14800
        //index 140 == lv 14000
        if (indexInterval >= 140
            && (seriesName === SequenceName.CostHero || seriesName === SequenceName.CostSupport))
        {
            let m = indexInterval - 140;
            ratio += 0.00005 + m * 0.0000025;
        }

        ratio = this.roundBy6Dec(ratio);

        //if(seriesName === SequenceName.DropCoins && indexInterval === 199) console.log(`SeriesCommonRatio seriesName: ${seriesName} indexInterval: ${indexInterval} ratio: ${ratio}`);
        return ratio;
    }

    GeometrySum(n, firstTerm, cmRatio, current = 1) {
        if (current <= 0) {
            console.log("Current must be bigger than zero!");
        }

        let u1 = firstTerm;
        let cmNum = SMPNum.fromNum(cmRatio);
        let u = SMPNum.multSmpNum(u1, cmNum.PowfromInt(current - 1));
        let sum = SMPNum.multSmpNum(u, SMPNum.divSmpNum(SMPNum.minus(cmNum.PowfromInt(n), SMPNum.fromNum(1)), SMPNum.minus(cmNum, SMPNum.fromNum(1))));
        return sum;
    }

    GetUnUsingSum(sum, firstTerm, cmRatio, current = 1) {
        if (current <= 0)
        {
            throw ("Current must be bigger than zero!");
        }

        let u1 = firstTerm;

        let u = SMPNum.multSmpNum(
            u1,
            SMPNum.pow(
                SMPNum.fromNum(cmRatio),
                current - 1
            )
        ) ;
        let first = SMPNum.plus(
            SMPNum.divSmpNum(
                SMPNum.multSmpNum(
                    sum,
                    SMPNum.fromNum(cmRatio - 1)
                ),
                u
            ),
            SMPNum.fromNum(1)
        );

        if(first.ToDoubleValue() >= cmRatio){
            let result = SMPNum.logBaseSmpNum(first, cmRatio);
            return result.ToDoubleIfPossible();
        } else {
            return 0;
        }
    }

    roundBy6Dec(num) {
        /*to fix
        on C# 1.06 - 1.05 = 0.00999999
        but on JS 1.06 - 1.05 = 0.010000000000000009
         */
        return Math.round(num * Math.pow(10, 6)) / Math.pow(10, 6);
    }
}

module.exports = SMPMathCore;